var bsv = require('../../')
bsv.Mnemonic = require('./mnemonic')

module.exports = bsv.Mnemonic
